<div class="container">
    <h3>{{ profile?.name }}</h3>
    <div class="lineInfo">
        <p [innerHTML]="profile?.wysiwygEditorContent" id="tinymce"></p>
    </div>
</div>
<button mat-raised-button color="primary" *ngIf="button" (click)="close()" matRipple>
    {{ 'INTERFACE|Wybierz' | translate }}
</button>
